export default function SgstList({ suggest, setDetail, setDetailData, auth }: any) {
  const detailHandler = (suggest: any) => {
    setDetailData(suggest);
    setDetail(true);
  };
  console.log(suggest)

  return (
    <div className={auth !== 'WOK' ? 'bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-154px)] md:h-[calc(100%-385px)]'
      : 'bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-118px)] md:h-[calc(100%-295px)]'}>
      <div className='w-[235px] sm:w-[308px] md:w-[750px] pt-10 md:pt-[25px] mb-20 md:mb-[50px]'>
        {suggest ? suggest.length > 0 ? suggest.map((suggest: any, idx: number) => {
          return (
            <div key={idx} onClick={() => detailHandler(suggest)}>
              <div className='flex mt-22 md:mt-[55px] justify-between items-center'>
                <p className='text-15 leading-18 md:text-37 md:leading-[45px] font-preBold truncate'>{suggest.evntNm}</p>
                {suggest.prcsStatCd === '001' ? <div className='w-63 h-26 md:w-[157px] md:h-[65px] bg-point text-13 leading-15 md:text-32 md:leading-[37px] rounded-[4px] md:rounded-[10px] text-white flex items-center justify-center font-preLight'>응답대기</div>
                  : <div className='w-63 h-26 md:w-[157px] md:h-[65px] bg-[#585959] text-13 leading-15 md:text-32 md:leading-[37px] rounded-[4px] text-white flex items-center justify-center font-preLight'>응답완료</div>
                }
              </div>
              <p className='text-14 leading-17 mt-7 md:text-35 md:leading-[42px] md:mt-[17px]'>{suggest.cmpnyNm} / <span>{suggest.exbtPlc}</span></p>
              <p className='text-14 leading-17 md:text-35 md:leading-[42px] md:mt-[20px] text-[#706F6F] truncate'>{suggest.cntnts}</p>
              <p className='text-14 leading-17 md:text-35 md:leading-[42px] md:mt-[20px] text-[#706F6F] truncate'>{suggest.rgstDt.substring(0,10)}</p>
              <div className='border border-x-0 border-t-0 border-[#CACACA] w-full mt-24 md:mt-[60px]' />
            </div>)
        }) : <p className={`text-15 leading-18  md:text-37 md:leading-[45px] font-preBold truncate`}>조회된 데이터가 없습니다.</p> : null}
      </div>
    </div>
  );
}



